export default "__VITE_ASSET__rR14AALz__"